export default __webpack_public_path__ + "assets/11d.639df886.svg";